<template>
  <div>
    <form @submit.prevent="validarCamposCuo" class="xcard" style="margin-top: 0" novalidate>
      <div v-if="cuota">
        <p><b>Numero Cuota:</b> {{ nro_cuota }}.</p>
        <p><b>Monto Cuota:</b> {{ monto }} Bs.</p>
        <p><b>Saldo:</b> {{ saldo }} Bs.</p>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('cuota.idcuota') }">
            <input type="text" v-model.trim="cuota.idcuota" class="form-control" placeholder="Id de la cuota" :disabled="true" />
            <small>Id</small>
            <div class="error" v-if="validation.hasError('cuota.idcuota')">{{ validation.firstError('cuota.idcuota') }}</div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('cuota.monto') }">
            <input type="text" v-model.trim="cuota.monto" class="form-control" placeholder="Monto cancelado" />
            <small>Monto</small>
            <div class="error" v-if="validation.hasError('cuota.monto')">{{ validation.firstError('cuota.monto') }}</div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('cuota.tipo_pago') }">
            <select v-model="cuota.tipo_pago" class="form-control form-control-sm">
              <option value="true">Credito</option>
              <option value="false">Contado</option>
            </select>
            <small>Tipo de pago</small>
            <div class="error" v-if="validation.hasError('cuota.tipo_pago')">{{ validation.firstError('cuota.tipo_pago') }}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('cuota.fecha_pago') }">
            <Fecha :model="cuota" :valueto="'fecha_pago'" />
            <small>Fecha de pago</small>
            <div class="error" v-if="validation.hasError('cuota.fecha_pago')">{{ validation.firstError('cuota.fecha_pago') }}</div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{ 'has-error': validation.hasError('cuota.descripcion') }">
            <input type="text" v-model.trim="cuota.descripcion" class="form-control" placeholder="Observaciones" />
            <small>Observacion</small>
            <div class="error" v-if="validation.hasError('cuota.descripcion')">{{ validation.firstError('cuota.descripcion') }}</div>
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <CerReciboPago id="modalrecibo" :model="modelrecibo" />
      <p class="text-center">{{ msg }}</p>
      <notifications group="auth2" position="bottom right" />
      <button class="btn btn-azul center-block" @click="validarCamposCuo">Registrar pago de cuota</button>
      <a v-if="recibo_activo" title="Recibo de pago." data-toggle="modal" data-target="#modalrecibo" @click="verRecibo()">
        <span class="text-white glyphicon glyphicon-print"></span> ver Recibo generado
      </a>
    </form>
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import Fecha from '@/components/AFecha.vue';
import Alertas from '@/components/AAlertas.vue';
import { error, errorPago, parseJsonError } from '@/components/Utils.js';
import CerReciboPago from '@/views/CerReciboPagoNewIns.vue';
import gql from 'graphql-tag';

export default {
  props: {
    cuotas_por_pagar: { type: Array, required: true },
  },
  data() {
    return {
      modelrecibo: { pago: {} },
      msg: 'No tiene que deber matricula para poder pagar esta cuota',
      activo: true,
      recibo_activo: false,
      nro_cuota: -1,
      saldo: -1,
      monto: -1,
      cuota: {
        idcuota: -1,
        monto: -1,
        tipo_pago: true,
        //forma_pago: true,
        fecha_pago: null,
        nro_recibo: null,
        descripcion: null,
      },
    };
  },
  components: { Fecha, Alertas, CerReciboPago },
  watch: {
    /*cuotas_por_pagar:function(){ 
      this.cuota.idcuota = this.cuotas_por_pagar[0].id;
      if( !this.cuotas_por_pagar[0].puede_pagar ){
        this.$notify( error( 'Aun no se puede pagar cuota',window.stringifyObject(this.cuotas_por_pagar[0]) ) );
      }
    },*/
    cuotas_por_pagar: {
      deep: true,
      handler() {
        this.cuota.idcuota = this.cuotas_por_pagar[0].id;
        if (!this.cuotas_por_pagar[0].puede_pagar) {
          this.msg = 'Aun no puede pagar esta cuota, asegurese que no debe la matricula.';
          this.$notify(errorPago('Aun no se puede pagar cuota', window.stringifyObject(this.cuotas_por_pagar[0])));
        }
      },
    },
    cuota: {
      deep: true,
      handler() {
        this.$refs.alertar.reset();
        window.sessionStorage.setItem('xcuota', JSON.stringify(this.cuota));

        if (this.monto == this.cuota.monto) this.cuota.tipo_pago = false;
        else this.cuota.tipo_pago = true;

        if (this.monto < this.cuota.monto) {
          this.$notify(error('Excedido', 'No debe pagar mas de la cuota establecida'));
        }

        /*if( !this.cuotas_por_pagar[0].puede_pagar ){
          this.msg = "Aun no puede pagar esta cuota, asegurese que no debe la matricula.";
        }*/
      },
    },
  },
  validators: {
    'cuota.idcuota'(value) {
      return Validator.value(value).required();
    },
    'cuota.monto'(value) {
      return Validator.value(value).required().digit();
    },
    'cuota.fecha_pago'(value) {
      return Validator.value(value).required();
    },
    'cuota.descripcion'(value) {
      return Validator.value(value).minLength(0).regex('^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$');
    },
  },
  methods: {
    validarCamposCuo() {
      if (!this.activo) return;
      this.activo = false;
      this.$validate().then((success) => {
        var obj = window.Object.assign({}, this.cuota);
        if (success) {
          if (this.cuota.fecha_pago == '') {
            this.$refs.alertar.invalido();
            this.$notify(error('Fecha', 'Falta la fecha del pago de cuota'));
            this.activo = true;
          } else {
            obj.monto = parseInt(obj.monto);
            obj.tipo_pago = obj.tipo_pago == 'true' ? true : false;
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');
            this.$refs.alertar.cargando();
            this.enviarDatos(obj);
          }
        } else {
          this.$refs.alertar.invalido();
          this.activo = true;
        }
      });
    },
    enviarDatos(obj) {
      var vue = this;
      const sql = gql`mutation{ realizarPagoCuota(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = '';
      // window.console.log('realizarPagoCuota', sql);

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then(({ data: { realizarPagoCuota } }) => {
          if (realizarPagoCuota.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('xcuota', null);
            this.activo = true;
            vue.recibo_activo = true;
          } else {
            var errores = JSON.stringify(realizarPagoCuota.errors);
            var obj = JSON.parse(errores);
            var vals = 'Error Desconocido';
            if (obj != null)
              obj.forEach(function (k) {
                vals += Object.values(k) + '-\n\t';
              });
            vue.msg = vals;
            vue.activo = true;
            vue.$refs.alertar.invalido();
          }

          // window.console.log(data);
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          // window.console.error(JSON.stringify(error));
          vue.msg = error;

          this.$notify(parseJsonError(error));
        });
    },
    verRecibo() {
      var nueva_inscripcion = JSON.parse(window.sessionStorage.getItem('nueva_inscripcion'));
      /*window.console.log( window.stringifyObject(this.cuota) )
      window.console.log( window.stringifyObject(this.saldo) )
      window.console.log( window.stringifyObject(this.cuotas_por_pagar) )*/
      this.modelrecibo.pago = this.cuota;
      this.modelrecibo.pago.saldo = this.saldo;
      this.modelrecibo.pago.cuota = nueva_inscripcion.cuotas_por_pagar[0];
      this.modelrecibo.estudiante = nueva_inscripcion.estudiante;
      this.modelrecibo.asesor = nueva_inscripcion.asesor;
      this.modelrecibo.inscripcion = nueva_inscripcion;
      //window.console.log( window.stringifyObject(nueva_inscripcion) )
    },
  },
  mounted() {
    // window.console.log('PAGAR CUOTA', window.sessionStorage.xcuota);
    // window.console.log('PAGAR CUOTAS', this.cuotas_por_pagar);

    var cuo = this.cuotas_por_pagar[0];
    if (cuo && cuo.id) {
      this.cuota.nro_recibo = `${Date.now()}`;
      this.cuota.idcuota = cuo.id;
      this.cuota.monto = cuo.monto;
      this.nro_cuota = cuo.nro_cuota;
      this.saldo = cuo.saldo;
      this.monto = cuo.monto;
      // window.console.log( "jajajajajaja",window.stringifyObject(cuo) )
    }
  },
};
</script>